// Collection pagination: resolve the current grid after Dawn replaces it during filtering.
(() => {
  if (window.bbgCollectionLoadMoreBound) return;
  window.bbgCollectionLoadMoreBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('#load-more-btn');
    if (!button || button.closest('[data-bbg-gallery-section]')) return;
    event.preventDefault();

    const grid = document.getElementById('product-grid');
    if (button.disabled || !grid?.dataset.nextUrl) return;
    const spinner = document.getElementById('load-more-spinner');
    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Loading more...';

    try {
      // Shopify's pagination URL includes the active collection filters and market.
      const url = new URL(grid.dataset.nextUrl, window.location.href);
      if (url.origin !== window.location.origin) throw new Error('Unexpected pagination origin');
      const view = new URLSearchParams(window.location.search).get('view');
      if (view) url.searchParams.set('view', view);
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Network error');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.getElementById('product-grid');
      if (!nextGrid) throw new Error('Missing product grid');

      // A filter may have replaced this grid while the request was in flight.
      if (!grid.isConnected || document.getElementById('product-grid') !== grid) return;
      [...nextGrid.children].forEach((item) => {
        if (item.matches('.grid__item')) grid.appendChild(document.importNode(item, true));
      });
      grid.dataset.nextUrl = nextGrid.dataset.nextUrl || '';
      if (!grid.dataset.nextUrl) button.remove();
    } catch (error) {
      console.error('Load More error:', error);
      button.textContent = 'Try loading more again';
    } finally {
      button.disabled = false;
      if (button.textContent === 'Loading more...') button.textContent = label;
      if (spinner) spinner.style.display = 'none';
    }
  });
})();
